export const typography = {
  fontFamily: "Roboto, sans-serif",
  fontSize: 14,
  h1: { fontSize: "2rem", fontWeight: 500 },
  h2: { fontSize: "1.5rem", fontWeight: 500 },
  h3: { fontSize: "1.25rem", fontWeight: 500 },
  body1: { fontSize: "0.875rem" },
};
